"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = exports.commonReducer = exports.ACTION = exports.getHeader = exports.generateXLSXCSV = exports.downloadFile = exports.ReportsApipath = void 0;
const XLSX = __importStar(require("xlsx"));
const getHeader = (token) => {
    const auth = token ? `Bearer ${token}` : `Bearer ${localStorage.getItem('access_token')}`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
    };
    if (auth) {
        headers.Authorization = auth;
    }
    return headers;
};
exports.getHeader = getHeader;
const ACTION = {
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
exports.ACTION = ACTION;
exports.ReportsApipath = {
    BILLWISE: "list_bills",
    ITEMWISE: "list_bill_items",
    DAYWISE: "list_datewise_bills",
    MONTHWISE: "monthwise",
    DUPLICATEBILL: "duplicate_bill",
    WRITEOFF: "writeoff",
    COUNTER: "counter",
    USER: "user",
    INVENTORY: "inventory",
    PAYMENT_MODE: "payment_mode",
    SUMMARY: "business"
};
// const APIPATH = "http://localhost:5000/api/v1/"
const commonReducer = (state, action) => {
    switch (action.type) {
        case ACTION.LOADING: {
            return Object.assign(Object.assign({}, state), { loading: true, error: false });
        }
        case ACTION.ERROR: {
            return Object.assign(Object.assign({}, state), { data: action.payload, loading: false, statusCode: action.statusCode, error: true });
        }
        case ACTION.SUCCESS: {
            return Object.assign(Object.assign({}, state), { data: action.payload, loading: false, error: false, totalRecords: action.total, statusCode: action.statusCode });
        }
        default: {
            return Object.assign(Object.assign({}, state), { error: true });
        }
    }
};
exports.commonReducer = commonReducer;
const isEmpty = (val) => {
    return (val === undefined || val == null || val === '') ? true : false;
};
exports.isEmpty = isEmpty;
function downloadFile(blob, filename) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return "CSV File Downloaded Successfully";
    });
}
exports.downloadFile = downloadFile;
function generateXLSXCSV(data, headers, filename) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            //  const mappedData:any = data.map((item) => {
            //   return headers.reduce((obj:any, key:any) => {
            //     obj[key.title] = item[key.field];
            //     return obj;
            //   }, {});
            // });
            const mappedData = data.map((item) => {
                return headers.reduce((obj, key) => {
                    const value = item[key.field];
                    obj[key.title] = typeof value === 'number' ? parseFloat(value.toFixed(2)) : value;
                    return obj;
                }, {});
            });
            // using xlsx package
            const ws = XLSX.utils.json_to_sheet(mappedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const csv = XLSX.utils.sheet_to_csv(ws);
            // Create a Blob from the CSV content
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            filename = filename.endsWith('.csv') ? filename : `${filename}.csv`;
            yield downloadFile(blob, filename);
            return "CSV File Downloaded Successfully";
        }
        catch (error) {
            console.error('Error while converting JSON to CSV', error);
            throw new Error('Error while converting JSON to CSV');
        }
    });
}
exports.generateXLSXCSV = generateXLSXCSV;
